import { useParams } from "react-router-dom";

const CONTENT = {
    terms: {
        title: "Terms of Sale",
        body: (
            <>
                <p>
                    RAX The Edit sells one-of-one, hand-picked pre-owned pieces. By placing an order
                    you accept these Terms of Sale in addition to the general Terms of Use.
                </p>
                <h2>1. The pieces</h2>
                <p>
                    Every piece is described honestly, condition-graded, and authenticated by our
                    curators. Because pieces are pre-owned, minor variations from photographs may
                    exist and are not defects.
                </p>
                <h2>2. Availability</h2>
                <p>
                    Each piece is unique — once sold, it is gone. Pieces in your bag are not
                    reserved until checkout is completed.
                </p>
                <h2>3. Prices &amp; payment</h2>
                <p>
                    All prices are in GBP and include VAT where applicable. Payment is taken by
                    Stripe. RAX never stores your card details.
                </p>
                <h2>4. Shipping</h2>
                <p>
                    Flat-rate £12 shipping across the UK. International shipping is available on
                    request. Please allow 2 business days for dispatch.
                </p>
                <h2>5. Returns</h2>
                <p>
                    See our <a href="/legal/returns" className="link-underline">Returns policy</a>.
                </p>
                <h2>6. Contact</h2>
                <p>hello@raxtheedit.com</p>
            </>
        ),
    },
    privacy: {
        title: "Privacy Policy",
        body: (
            <>
                <p>
                    RAX The Edit is committed to protecting your privacy in line with the UK GDPR
                    and Data Protection Act 2018.
                </p>
                <h2>What we collect</h2>
                <p>
                    Order details, shipping address, email, and — for consignors — the details of
                    pieces you submit. We do not sell or share your data with third parties beyond
                    what is required to fulfil orders (Stripe for payment, Brevo for email).
                </p>
                <h2>Marketing</h2>
                <p>
                    We only send marketing emails to people who have explicitly subscribed. You can
                    unsubscribe from any email at any time.
                </p>
                <h2>Your rights</h2>
                <p>
                    You can request a copy of, correction to, or deletion of your data at any time
                    by writing to hello@raxtheedit.com.
                </p>
                <h2>Cookies</h2>
                <p>
                    See our <a href="/legal/cookies" className="link-underline">Cookies policy</a>.
                </p>
            </>
        ),
    },
    returns: {
        title: "Shipping &amp; Returns",
        body: (
            <>
                <h2>Shipping</h2>
                <p>
                    Flat-rate £12 across the UK, dispatched within 2 business days from London in
                    RAX packaging. International shipping available on request — please email us at
                    hello@raxtheedit.com.
                </p>
                <h2>Returns</h2>
                <p>
                    We accept returns within 14 days of delivery on unworn pieces with all tags
                    intact. Returned pieces are inspected on arrival. If a return fails inspection
                    it may be returned to you.
                </p>
                <p>
                    Sale pieces (marked as such) are final sale and cannot be returned.
                </p>
                <h2>Refunds</h2>
                <p>
                    Refunds are processed to the original payment method within 5 business days of
                    inspection. Shipping is non-refundable.
                </p>
            </>
        ),
    },
    consignor: {
        title: "Consignor Agreement",
        body: (
            <>
                <p>
                    Thank you for consigning with RAX. This agreement sets out how we work
                    together.
                </p>
                <h2>Submission &amp; review</h2>
                <p>
                    You submit pieces via the Sell With Us form with accurate photographs and
                    condition detail. We review and either accept or decline within 3–5 working
                    days.
                </p>
                <h2>Photography, styling &amp; listing</h2>
                <p>
                    Accepted pieces are photographed and styled by RAX at our expense. We set a
                    final list price after review, in consultation with you where required.
                </p>
                <h2>Commission</h2>
                <p>
                    Standard split: <strong>70% consignor / 30% RAX</strong>. Pieces under £150
                    settle at <strong>60/40</strong>. VAT (where applicable) is deducted before
                    commission is calculated.
                </p>
                <h2>Payout</h2>
                <p>
                    Payout is issued within 14 days of sale confirmation to the payment method of
                    your choice. In the MVP payouts are processed manually; automated Connect
                    payouts follow in Phase 2.
                </p>
                <h2>Unsold pieces</h2>
                <p>
                    If a piece hasn&rsquo;t sold in 90 days we may adjust the price with your
                    consent or return the piece at your request.
                </p>
                <h2>Authenticity &amp; condition</h2>
                <p>
                    You warrant that pieces are authentic and accurately described. Pieces that
                    fail authentication on arrival will be returned to you.
                </p>
            </>
        ),
    },
    cookies: {
        title: "Cookies",
        body: (
            <>
                <p>
                    RAX uses a light touch of cookies to make the site work. We do not sell your
                    data or serve third-party advertising cookies.
                </p>
                <h2>Essential</h2>
                <p>Authentication token cookies to keep you signed in; cart contents in local storage.</p>
                <h2>Analytics</h2>
                <p>
                    Aggregated, privacy-friendly analytics to understand how the site is used. No
                    cross-site tracking.
                </p>
                <h2>Your choice</h2>
                <p>
                    You can decline non-essential cookies via the banner at the bottom of the site
                    when you first visit.
                </p>
            </>
        ),
    },
};

export default function Legal() {
    const { slug } = useParams();
    const content = CONTENT[slug] || CONTENT.terms;
    return (
        <article className="legal-page" data-testid={`legal-${slug || "terms"}`}>
            <div className="meta">RAX The Edit</div>
            <h1>{content.title}</h1>
            <div className="meta" style={{ margin: "0 0 24px" }}>
                Last updated · December 2025
            </div>
            {content.body}
        </article>
    );
}
